import Chart from 'chart.js/auto';
import {AlgoBase} from "./AlgoBase";
import Papaparse from "papaparse";

export class Aquilon2ChartJS extends AlgoBase {

  constructor(target) {
    super("aquilon", target, false);
    this.init();
  }

  async init() {

    this.algortihmData = await this.buildDataset("data/algorithms/Aquilon2.csv");

    const ctx = this.$widget.find("canvas");

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.algortihmData.labels,
        datasets: [{
          label: 'Total daily KWh (WITH AI)', // [dynamic value in loadDataset()],
          data: this.algortihmData.mainDatasets[0],
          borderColor: '#E62B33',
        }, {
          label: 'Total daily KW (WITHOUT AI)', // [dynamic value in loadDataset()],
          data: this.algortihmData.withoutAIDatasets[0],
          borderColor: '#000000',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          // annotation: {
          // annotations: {
          //   line1: {
          //     type: 'line',
          //     borderColor: '#3729AF', // Line color
          //     borderWidth: 3, // Line width
          //     drawTime: 'beforeDraw',
          //     yMin: 0,
          //     yMax: 0,
          //     z: 1,
          //   },
          // }
          // }
        },
        elements: {
          line: {
            tension: 0.3,
            borderColor: '#330808',
          }
        },
        scales: {
          x: this.setupXAxis(this.algortihmData.labels.length / 6),
          y: {
            min: 0,
            max: 3000,
            ticks: {
              callback: function (value, index, ticks) {
                return value + ' kWh'; // Append the unit
              }
            },
          }
        },
        layout: {
          padding: {
            left: 5,
            right: 34,
          }
        }
      }
    });

    this.loadDataset(0)

    this.initEvents();

    this.ready();
  }

  loadDataset(datasetIndex) {
    this.chart.data.datasets[1].data = this.algortihmData.withoutAIDatasets[datasetIndex];

    // Update dynamic strings from CMS
    this.chart.data.datasets[0].label = this.getLegendFromCMS(1, 2);
    this.chart.data.datasets[1].label = this.getLegendFromCMS(2, 2);

    super.loadDataset(datasetIndex);
  }

  async buildDataset(filename) {
    const singleDataSetBuild = await super.buildDatasetFromCSV(filename, 1);
    const withoutAIDatasets = singleDataSetBuild.mainDatasets.splice(singleDataSetBuild.mainDatasets.length/2)
    return {
      labels: singleDataSetBuild.labels,
      mainDatasets: singleDataSetBuild.mainDatasets,
      withoutAIDatasets: withoutAIDatasets,
    };
  }

}
